/* eslint-disable */
/**
   * 将字符串中的特殊字符转换为实体
   * @param {String} str 待转换字符串
   */
function encodeHtml(str) {
  return `${str}`
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\x60/g, '&#96;')
    .replace(/\x27/g, '&#39;')
    .replace(/\x22/g, '&quot;');
}
/**
 * Hybrid Util class
 * @class
 */
class HybridUtil {
  /**
   * 解析url
   * @method
   * @param {String} url 统一资源定位符，例如：http://www.pengyou.com
   * @return {Object} location对象
   * @example parseUrl('http://www.pengyou.com')
   */
  parseUrl(url) {
    const a = document.createElement('a');
    let rs = {};
    a.href = url;
    rs = {
      href: url,
      origin: undefined,
      protocol: a.protocol.replace(':', ''),
      hostname: a.hostname,
      host: a.hostname,
      port: a.port,
      search: a.search,
      hash: a.hash,
      pathname: a.pathname.replace(/^([^/])/, '/$1'),
      params: (function () {
        const ret = {};
        const seg = a.search.replace(/^\?/, '').split('&');
        const len = seg.length;
        let i = 0;
        for (; i < len; i += 1) {
          if (!seg[i]) {
            /* eslint-disable-next-line */
            continue;
          }
          const pos = seg[i].indexOf('=');
          ret[seg[i].substr(0, pos)] = encodeHtml(decodeURIComponent(escape(seg[i].substr(pos + 1))));
          // 过滤xss；防止%27%3Bthis%5B8680439..toString%2830%29%5D%28902730324%29%3B%2F%2F%27报错
        }
        return ret;
      }()),
    };
    return rs;
  }

  /**
   * 获取某个url地址的请求的对象
   */
  getQueryObj(url) {
    const newUrl = url || window.location.href;
    return this.parseUrl(newUrl).params;
  }

  /**
   * 格式化剩余时间
   * @param {Number} ms 剩余时间（毫秒）
   * @returns {String} 格式化后的剩余时间
   */
  formatLeftTime(ms) {
    let s = 0;
    let m = 0;
    let h = 0;
    s = parseInt(ms / 1000);
    s = s || 1;
    if (s >= 60) {
      m = parseInt(s / 60);
      s %= 60;
    }
    if (m >= 60) {
      h = parseInt(m / 60);
      m %= 60;
    }
    return [h ? `${h}小时` : '', m ? `${m}分` : '', s ? `${s}秒` : ''].join('');
  }

  /**
   * 将对象转换为URL参数串
   * @param {Object} obj 待转换对象
   * @returns {String} 转换后的URL参数串
   */
  toUrlParam(obj) {
    const res = [];
    if (!obj) {
      return '';
    }
    for (const p in obj) {
      if (
        (typeof obj[p] === 'string' && obj[p])
        || typeof obj[p] === 'number'
      ) {
        res.push(`${p}=${encodeURIComponent(obj[p])}`);
      }
    }
    return res.join('&');
  }

  /**
   * 在URL后追加参数
   * @param {String} url 待追加的URL
   * @param {String|Object} param 追加的参数
   * @param {Boolean} isHashMode 参数是否追加在HASH里面
   * @returns {String} 追加后的URL
   */
  appendUrlParam(url, param, isHashMode) {
    let newParam = '';
    let newUrl = url;
    if (typeof param === 'string') {
      newParam = param.replace(/^&/, '');
    } else {
      newParam = this.toUrlParam(param);
    }
    if (!newParam) {
      return url;
    }
    if (isHashMode) {
      if (url.indexOf('#') == -1) {
        newUrl += `#${newParam}`;
      } else {
        newUrl += `&${newParam}`;
      }
    } else if (url.indexOf('#') == -1) {
      if (url.indexOf('?') == -1) {
        newUrl += `?${newParam}`;
      } else {
        newUrl += `&${newParam}`;
      }
    } else {
      const tmp = url.split('#');
      if (tmp[0].indexOf('?') == -1) {
        newUrl = `${tmp[0]}?${newParam}#${tmp[1] || ''}`;
      } else {
        newUrl = `${tmp[0]}&${newParam}#${tmp[1] || ''}`;
      }
    }
    return newUrl;
  }

  /**
   * 将字符串中的特殊字符转换为实体
   * @param {String} str 待转换字符串
   */
  encodeHtml(str) {
    return encodeHtml(str);
  }

  /**
   * 将字符串中的实体转换为原字符
   * @param {String} str 待转换字符串
   */
  decodeHtml(str) {
    return `${str}`
      .replace(/&quot;/g, '\x22')
      .replace(/&#0*39;/g, '\x27')
      .replace(/&#0*96;/g, '\x60')
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&amp;/g, '&');
  }

  /** 截断文本
   * @param
   */
  cut(string, bitLen, tails) {
    const str = String(string);
    /* eslint-disable-next-line */
    bitLen -= 0;
    /* eslint-disable-next-line */
    tails = tails || '...';
    /* eslint-disable-next-line */
    if (isNaN(bitLen)) return str;
    const len = str.length;
    let i = Math.min(Math.floor(bitLen / 2), len);
    let cnt = this.getRealLen(str.slice(0, i));
    for (; i < len && cnt < bitLen; i += 1) cnt += 1 + (str.charCodeAt(i) > 255);
    return str.slice(0, cnt > bitLen ? i - 1 : i) + (i < len ? tails : '');
  }

  getRealLen(s, isUTF8) {
    if (typeof s !== 'string') return 0;
    if (!isUTF8) return s.replace(/[^\x00-\xFF]/g, '**').length;

    const cc = s.replace(/[\x00-\xFF]/g, '');
    /* eslint-disable */
    return s.length - cc.length + encodeURI(cc).length / 3;
  }

  /**
   * 插入页面inline样式块
   * @param {string} sheetId 样式表style Element的ID
   * @param {string} [rules=""] 样式表规则内容
   * @returns {object} 返回样式表style Element对象

   * @example QZFL.css.insertStyleSheet("cssid", "body {font-size: 75%;}");
   */
  insertStyleSheet(sheetId, rules) {
    const node = document.createElement('style');
    node.type = 'text/css';
    if (sheetId) {
      node.id = sheetId;
    }
    document.getElementsByTagName('head')[0].appendChild(node);
    if (rules) {
      if (node.styleSheet) {
        node.styleSheet.cssText = rules;
      } else {
        node.appendChild(document.createTextNode(rules));
      }
    }
    return node.sheet || node;
  }

  insertStyleLink(linkId, url) {
    const node = document.createElement('link');
    node.rel = 'stylesheet';
    if (linkId) {
      node.id = linkId;
    }
    document.getElementsByTagName('head')[0].appendChild(node);
    if (url) {
      node.href = url;
    }
    return node;
  }

  /**
   * 使用视网膜屏幕图片的时候，从该函数获取图片的点后缀
   * @example Example
   * 例：imgurl = "logo"+Util.imgdpr()+"png";
   * @return {*}
   */
  imgdpr() {
    if (window.devicePixelRatio > 1.3) {
      return '@2x.';
    }
    return '.';
  }

  /**
   * 日期格式化方法
   * @param {Date} date 待格式化Date对象
   * @param {String} format 格式化的格式，例如：'yyyy-MM-dd HH:mm:ss'
   * @returns {String} 格式化后字符串
   */
  formatDate(date, format) {
    let res = format;
    let tt = '';
    res = res
      .replace(/yyyy|yy/, ($0) => {
        if ($0.length === 4) {
          return date.getFullYear();
        }
        return `${date.getFullYear()}`.slice(2, 4);
      })
      .replace(/MM|M/, ($0) => {
        if ($0.length === 2 && date.getMonth() < 9) {
          return `0${date.getMonth() + 1}`;
        }
        return date.getMonth() + 1;
      })
      .replace(/dd|d/, ($0) => {
        if ($0.length === 2 && date.getDate() < 10) {
          return `0${date.getDate()}`;
        }
        return date.getDate();
      })
      .replace(/HH|H/, ($0) => {
        if ($0.length === 2 && date.getHours() < 10) {
          return `0${date.getHours()}`;
        }
        return date.getHours();
      })
      .replace(/hh|h/, ($0) => {
        let hours = date.getHours();
        if (hours > 11) {
          tt = 'PM';
        } else {
          tt = 'AM';
        }
        hours = hours > 12 ? hours - 12 : hours;
        if ($0.length === 2 && hours < 10) {
          return `0${hours}`;
        }
        return hours;
      })
      .replace(/mm/, () => {
        if (date.getMinutes() < 10) {
          return `0${date.getMinutes()}`;
        }
        return date.getMinutes();
      })
      .replace(/ss/, () => {
        if (date.getSeconds() < 10) {
          return `0${date.getSeconds()}`;
        }
        return date.getSeconds();
      })
      .replace('tt', tt);
    return res;
  }

  /**
   * 主要的使用场景是手机，用来在跳转的时候自动加上登录态
   */
  jumpto(url) {
    // require.async('./user', (user) => {
    //   const loginStatus = {
    //     sid: user.getSid(),
    //     B_UID: user.getUin(),
    //   };
    //   window.location.href = this.appendUrlParam(url, loginStatus);
    // });
    window.location.href = url;
  }

  /**
   * URL参数提取方法
   * @param {String} name 参数名称
   * @param {Object} loc location对象，默认用window.location
   */
  getUrlParam(name, loc) {
    const newLoc = loc || window.location;
    const r = new RegExp(`(\\?|#|&)${name}=(.*?)(&|#|$)`);
    const m = (newLoc.href || '').match(r);
    return this.encodeHtml(decodeURIComponent(m ? m[2] : ''));
  }

  /**
   * 格式化qua
   * @param {String} qua string
   * @returns {Object} qua object
   */
  formatQua(strQua) {
    // 兼容大小写
    const newStrQua = strQua.toUpperCase();
    const arr = newStrQua.split('_');
    const OS_REG = /^(AND|IOS|IPH)$/;
    const APP_REG = /^(SQ|QZ)$/;
    const VER_REG = /^\d+\.\d+\.\d+$/;
    const SUB_VER_REG = /^\d+$/;
    let res;
    if (
      arr.length == 7
      && OS_REG.test(arr[1])
      && APP_REG.test(arr[2])
      && VER_REG.test(arr[3])
      && SUB_VER_REG.test(arr[4])
    ) {
      // 这里的meybeQua是笔误，先保持用这个好了
      res = {
        os: arr[1],
        version: arr[3],
        subVersion: arr[4],
        appType: arr[5],
        meybeQua: strQua,
      };
    } else {
      res = {};
    }
    return res;
  }

  /**
   * base 64算法
   * 注意:在原来base64算法上做了一些替换 区分encode和encodeURI两个不同方法
   *    =   -->  !
   *    +   -->  .
   *    /   -->  *
   */
  base64() {
    // constants
    const b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const b64tab = (function (bin) {
      const t = {};
      for (let i = 0, l = bin.length; i < l; i += 1) t[bin.charAt(i)] = i;
      return t;
    }(b64chars));
    const { fromCharCode } = String;
    // encoder stuff
    // eslint-disable-next-line camelcase
    const cb_utob = function (c) {
      let cc = '';
      if (c.length < 2) {
        cc = c.charCodeAt(0);
        // eslint-disable-next-line no-nested-ternary
        return cc < 0x80
          ? c
          : cc < 0x800
            // eslint-disable-next-line no-bitwise
            ? fromCharCode(0xc0 | (cc >>> 6)) + fromCharCode(0x80 | (cc & 0x3f))
            // eslint-disable-next-line no-bitwise
            : fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
            // eslint-disable-next-line no-bitwise
            + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
            // eslint-disable-next-line no-bitwise
            + fromCharCode(0x80 | (cc & 0x3f));
      }
      cc = 0x10000
        + (c.charCodeAt(0) - 0xd800) * 0x400
        + (c.charCodeAt(1) - 0xdc00);
      return (
        // eslint-disable-next-line no-bitwise
        fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
        // eslint-disable-next-line no-bitwise
        + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
        // eslint-disable-next-line no-bitwise
        + fromCharCode(0x80 | ((cc >>> 6) & 0x3f))
        // eslint-disable-next-line no-bitwise
        + fromCharCode(0x80 | (cc & 0x3f))
      );
    };
    // eslint-disable-next-line camelcase
    const re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    const utob = function (u) {
      return u.replace(re_utob, cb_utob);
    };
    // eslint-disable-next-line camelcase
    const cb_encode = function (ccc) {
      const padlen = [0, 2, 1][ccc.length % 3];
      const ord = (ccc.charCodeAt(0) << 16)
        | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
        | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
      const chars = [
        b64chars.charAt(ord >>> 18),
        b64chars.charAt((ord >>> 12) & 63),
        padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
        padlen >= 1 ? '=' : b64chars.charAt(ord & 63),
      ];
      return chars.join('');
    };
    const btoa = function (b) {
      return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    // eslint-disable-next-line no-underscore-dangle
    const _encode = function (u) {
      return btoa(utob(u));
    };

    const encode = function (u, urisafe) {
      return !urisafe
        ? _encode(u)
        : _encode(u)
          // eslint-disable-next-line no-useless-escape
          .replace(/[+\/]/g, m0 => (m0 == '+' ? '.' : '*'))
          .replace(/=/g, '');
    };
    const encodeURI = function (u) {
      return encode(u, true);
    };
    // decoder stuff
    // eslint-disable-next-line camelcase
    const re_btou = new RegExp(
      [
        '[\xC0-\xDF][\x80-\xBF]',
        '[\xE0-\xEF][\x80-\xBF]{2}',
        '[\xF0-\xF7][\x80-\xBF]{3}',
      ].join('|'),
      'g',
    );
    // eslint-disable-next-line camelcase
    const cb_btou = function (cccc) {
      let cp = 0;
      let offset = 0;
      switch (cccc.length) {
        case 4:
          cp = ((0x07 & cccc.charCodeAt(0)) << 18)
            | ((0x3f & cccc.charCodeAt(1)) << 12)
            | ((0x3f & cccc.charCodeAt(2)) << 6)
            | (0x3f & cccc.charCodeAt(3));
          offset = cp - 0x10000;
          return (
            fromCharCode((offset >>> 10) + 0xd800)
            + fromCharCode((offset & 0x3ff) + 0xdc00)
          );
        case 3:
          return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
              | ((0x3f & cccc.charCodeAt(1)) << 6)
              | (0x3f & cccc.charCodeAt(2)));
        default:
          return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6) | (0x3f & cccc.charCodeAt(1)));
      }
    };
    const btou = function (b) {
      return b.replace(re_btou, cb_btou);
    };
    // eslint-disable-next-line camelcase
    const cb_decode = function (cccc) {
      const len = cccc.length;
      const padlen = len % 4;
      const n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
        | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
        | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0)
        | (len > 3 ? b64tab[cccc.charAt(3)] : 0);
      const chars = [
        fromCharCode(n >>> 16),
        fromCharCode((n >>> 8) & 0xff),
        fromCharCode(n & 0xff),
      ];
      chars.length -= [0, 0, 2, 1][padlen];
      return chars.join('');
    };
    const atob = function (a) {
      return a.replace(/[\s\S]{1,4}/g, cb_decode);
    };
    // eslint-disable-next-line no-underscore-dangle
    const _decode = function (a) {
      return btou(atob(a));
    };
    const decode = function (a) {
      return _decode(a
      // eslint-disable-next-line no-useless-escape
        .replace(/[\.\*]/g, m0 => (m0 == '.' ? '+' : '/'))
      // eslint-disable-next-line no-useless-escape
        .replace(/[^A-Za-z0-9\+\/]/g, ''));
    };

    const Base64 = {
      atob,
      btoa,
      fromBase64: decode,
      toBase64: encode,
      utob,
      encode, // 这个方法是正宗的base64算法
      encodeURI, // 这个是根据我们后台变种的base64算法
      btou,
      decode,
    };

    return Base64;
  }

  /**
   * base 62算法
   * 用于获取qq头像
   */
  base62() {
    return {
      decode(a) {
        return this.base64().decode(a
          .replace(/ic/g, '/')
          .replace(/ib/g, '+')
          .replace(/ia/g, 'i'));
      },
      encode(a) {
        return this
          .base64()
          .encode(a)
          // eslint-disable-next-line no-useless-escape
          .replace(/[=i\+\/]/g, (m) => {
            switch (m) {
              case '=':
                return '';
              case 'i':
                return 'ia';
              case '+':
                return 'ib';
              case '/':
                return 'ic';
              default:
                return '';
            }
          });
      },
    };
  }

  // 因为ios强推ats，要求页面全部切https，故这里新增http转https方法
  http2https(url) {
    url = url || '';
    let result;
    if (typeof (url) === 'string') {
      result = url.replace('http://', 'https://');
    } else {
      result = url;
    }
    return result;
  }

  /**
   * 把图像em标签转换为img图片标签
   * @param {String} 待处理内容
   * @returns {String} 处理后的的内容
   */
  transferUbbToImg(content) {
    const imgName = window.devicePixelRatio > 1 ? '@2x' : '';
    const isIOS = /iPhone|iPad/.test(navigator.userAgent);
    const reg = new RegExp('\\[em\\]e(\\d{3,10})\\[\\/em\\]', 'g');
    let newContent = content;
    let result;
    let emojiImg;

    // 因为重构那边不能提供静态的gif，所以空间表情用png（数字小于200的就是空间表情），emoji用gif
    // eslint-disable-next-line no-cond-assign
    while ((result = reg.exec(content))) {
      // eslint-disable-next-line no-nested-ternary
      const imgType = isIOS ? '.gif' : result[1] < 200 ? '.png' : '.gif';
      emojiImg = `<img class='i-emoji-m' src='//qzonestyle.gtimg.cn/qzone/em/e${
        result[1]
      }${imgName}${imgType}' alt='表情' >`;
      newContent = newContent.replace(result[0], emojiImg);
    }

    return newContent;
  }

  /**
   * 检测是否页面到底
   * @param size
   * @returns {boolean}
   */
  isBottom(size) {
    return (
      document.body.scrollHeight
        - document.body.scrollTop
        - window.innerHeight
      < (size || 50)
    );
  }

  /**
   * 获取一个对象某个属性路径下的值，从头到尾遍历路径pathsp，取到就返回，取不到就放回默认值
   * @param {Object} obj 对象(Object) 需要取值的对象 比如: {a: { b: { c: { d: 1, e: 2 } } } }
   * @param {String|Array} 字符串(string)/字符串数组(string array) 取值的路径 比如: ['a.b.c.d', 'a.b.c.e']
   * @param {any} defaultValue 取不到值的默认值 比如: ''
   * @returns {any}  取到的值 比如: 1
   */
  getValueByPaths(obj, paths, defaultValue) {
    if (!paths || !obj) {
      return obj;
    }
    const newPaths = [].concat(paths);
    let tar = obj;
    for (let i = 0; i < newPaths.length; i += 1) {
      let path = newPaths[i];
      if (Object.prototype.toString.call(path) !== '[object String]') {
        // eslint-disable-next-line no-continue
        continue;
      }
      path = path.trim();
      path = path.replace(/^\.|\.$/g, '');
      const pathFrags = path.split('.');
      for (let j = 0; j < pathFrags.length; j += 1) {
        const frag = pathFrags[j];
        if (tar[frag] !== undefined && tar[frag] !== null) {
          if (j === (pathFrags.length - 1)) {
            tar = tar[frag];
            return tar;
          }
          tar = tar[frag];
        } else {
          if (i === newPaths.length - 1) {
            return defaultValue;
          }
          break;
        }
      }
    }
    return defaultValue;
  }

  /**
   * 截取gif图片第一帧(异步)
   * @param {String} url gif url
   * @param {Function} callback callback
   */
  getSnapUrl(url, callback) {
    if (!url) {
      if (callback) {
        callback(url);
      }
    }

    const canvas = document.createElement('canvas');
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      const { width } = this; const
        { height } = this;
      if (width && height) {
        canvas.width = width;
        canvas.height = height;
        // 绘制图片帧（第一帧）
        canvas.getContext('2d').drawImage(this, 0, 0, width, height);
        try {
          const base64Url = canvas.toDataURL('image/gif');
          if (callback) {
            callback(base64Url);
          }
        } catch (e) {
          if (callback) {
            callback(url);
          }
        }
      }
    };

    image.onerror = function () {
      if (callback) {
        callback(url);
      }
    };
    image.src = url.replace(/https?\/\//, '//proxy.gtimg.cn/tx_tls_gate=');
  }
}

export default new HybridUtil();
